import styled from "styled-components";
import { P } from "../../design-system/text";

/**
 * A component wrapping the main body text of the About section
 */
export const About = styled(P)`
  font-size: 16px;
  white-space: pre-line;
`;